import { render, staticRenderFns } from "./EmailTemplateMgmt.vue?vue&type=template&id=5ddcdd84&"
import script from "./EmailTemplateMgmt.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports